import { useState } from 'react';
import { loginUrl } from '../lib/rpc';
import { stashTaskLink } from '../lib/deepLink';
import { Icon } from '../components/Icon';

const MESSAGES: Record<string, string> = {
  erro: 'Não foi possível entrar com a Microsoft. Tente de novo.',
  negado: 'Seu usuário não tem acesso. Fale com o administrador.',
};

/** Resultado devolvido pela API no retorno do login (?login=erro|negado); limpa a URL. */
function returnedMessage(): string | null {
  stashTaskLink();
  const r = new URLSearchParams(location.search).get('login');
  if (!r) return null;
  history.replaceState(null, '', location.pathname);
  return MESSAGES[r] ?? MESSAGES.erro;
}

/** Entrada só pela conta corporativa: a API do Quadro faz o login com o Entra ID. */
export function LoginPage() {
  const [message] = useState(returnedMessage);
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand"><Icon name="logo" /><span>Quadro</span></div>
        <h1>Entrar</h1>
        <p className="muted">Use sua conta Microsoft da empresa.</p>
        {message && <p className="auth-error" role="alert">{message}</p>}
        <a className="btn primary" href={loginUrl}>Entrar com Microsoft</a>
      </div>
    </div>
  );
}
